import RecipientField from "components/Reusable/SideBar/Share/RecipientField";
import React from "react";

export const EmbedShareFields = {
  ShareToEmailSenderTitle: {
    element: "input",
    fieldKey: "ShareToEmailSenderTitle",
    type: "email",
    title: "ShareToEmailSenderTitle",
    label: "your-email",
    defaultValue: "userMail",
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    },
  },
  ShareToEmailRecipientTitle: {
    element: "customelement",
    fieldKey: "ShareToEmailRecipientTitle",
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    },
    render: (props) => <RecipientField {...props} />,
  },
  ShareToEmailBodyTitle: {
    element: "textarea",
    fieldKey: "ShareToEmailBodyTitle",
    type: "text",
    title: "ShareToEmailBodyTitle",
    label: "share-mail-message",
    autoResize: true,
  },
};
